import { render, staticRenderFns } from "./ConvertTaskToProjectComponent.vue?vue&type=template&id=2e1eac28&"
import script from "./ConvertTaskToProjectComponent.vue?vue&type=script&lang=ts&"
export * from "./ConvertTaskToProjectComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports